import { render, staticRenderFns } from "./leaveRow.vue?vue&type=template&id=0df49b31&scoped=true&"
import script from "./leaveRow.vue?vue&type=script&lang=js&"
export * from "./leaveRow.vue?vue&type=script&lang=js&"
import style0 from "./leaveRow.vue?vue&type=style&index=0&id=0df49b31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df49b31",
  null
  
)

export default component.exports